// @flow
import type { UserLocation } from 'api/userLocation';
import type { Action } from '../actions/userLocation';

export type State = {
  ...UserLocation,
  isFetching?: boolean,
  isLoaded?: boolean
};

export default function userLocation(state: State = {}, action: Action) {
  switch (action.type) {
    case 'USER_LOCATION_FETCH_REQUEST':
      return {
        ...state,
        isFetching: true
      };
    case 'USER_LOCATION_FETCH_SUCCESS':
      return {
        ...action.userLocation,
        isFetching: false,
        isLoaded: true
      };
    default:
      // this causes a flow error if there are any unhandled actions
      (action: empty); // eslint-disable-line no-unused-expressions
      return state;
  }
}
